import React from 'react';
import styled from 'styled-components';

import { useLanguage } from '../../../Context/LanguageContext';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';

import HistoryContent from './HistoryContent';

export default function MessageHistoryBox(props) {
  const {
    viewMessageHistory,
    nowPage,
    totalPage,
    onClickPrev,
    onClickNext,
  } = props;

  const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  return (
    <MessageBoxWrapper>
      <HistoryColumnWrapper>
        <HistoryTextWrapper width={110}>
          <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} hover='default'>{t('messageSend.history.sendTime')}</Text>
        </HistoryTextWrapper>
        <DivisionLine backgroundColor={theme.buttonStroke} />
        <HistoryTextWrapper width={99}>
          <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} hover='default'>{t('messageSend.history.division')}</Text>
        </HistoryTextWrapper>
        <DivisionLine backgroundColor={theme.buttonStroke} />
        <HistoryTextWrapper width={524}>
          <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} hover='default'>{t('messageSend.history.content')}</Text>
        </HistoryTextWrapper>
        <DivisionLine backgroundColor={theme.buttonStroke} />
        <HistoryTextWrapper width={99} style={{ justifyContent: 'center', alignItems: 'center' }}>
          <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} hover='default'>{t('messageSend.history.sendCount')}</Text>
        </HistoryTextWrapper>
        <DivisionLine backgroundColor={theme.buttonStroke} />
        <HistoryTextWrapper width={99} style={{ justifyContent: 'center', alignItems: 'center' }}>
          <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} hover='default'>{t('messageSend.history.success')}</Text>
        </HistoryTextWrapper>
        <DivisionLine backgroundColor={theme.buttonStroke} />
        <HistoryTextWrapper width={99} style={{ justifyContent: 'center', alignItems: 'center' }}>
          <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} hover='default'>{t('messageSend.history.failed')}</Text>
        </HistoryTextWrapper>
      </HistoryColumnWrapper>
      {
        viewMessageHistory.length === 0 ?
          <HistoryTotalWrapper style={{ justifyContent: 'center' }}>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.line} hover='default'>{t('messageSend.history.noHistory')}</Text>
          </HistoryTotalWrapper>
          :
          <HistoryTotalWrapper>
            {
              viewMessageHistory.map((data, index) => (
                <HistoryContentWrapper key={'MessageHistory-' + index}>
                  <HistoryContent index={index} data={data} />
                </HistoryContentWrapper>
              ))
            }
          </HistoryTotalWrapper>
      }
      <PaginationTotalWrapper>
        <PaginationWrapper>
          <PaginationButtonWrapper onClick={onClickPrev}>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={nowPage === 0 ? theme.line : theme.text} hover='pointer'>{t('messageSend.history.prev')}</Text>
          </PaginationButtonWrapper>
          <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} hover='default'>{nowPage + 1}/{totalPage === 0 ? 1 : totalPage}</Text>
          <PaginationButtonWrapper onClick={onClickNext}>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={nowPage === totalPage - 1 ? theme.line : theme.text} hover='pointer'>{t('messageSend.history.next')}</Text>
          </PaginationButtonWrapper>
        </PaginationWrapper>
      </PaginationTotalWrapper>
    </MessageBoxWrapper>
  )
}

const MessageBoxWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 0px;

  width: 1001px;
`;

const HistoryColumnWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  margin-top: 20px;

  width: 100%;
  height: 41px;

  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background-color: ${props => props.theme.buttonFill};
`;

const HistoryTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding: 0px 10px;

  box-sizing: border-box;
  width: ${props => props.width}px;
  height: 41px;
`;

const DivisionLine = styled.div`
  width: 1px;
  height: 100%;

  background-color: ${props => props.backgroundColor};
`;

const HistoryTotalWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 100%;
  min-height: 100px;

  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  background-color: ${props => props.theme.subBackground};
`;

const HistoryContentWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 100%;
`;

const PaginationTotalWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-top: 22px;

  width: 100%;
`;

const PaginationWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 12px;
`;

const PaginationButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  @media (hover: hover) {
    &:hover {
      cursor: ${props => props.hover};
    }
  }
`;
